export default function NavBar() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-paper/95 backdrop-blur-sm border-b border-gray-200/60"
    >
      <div className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-20">
        <div className="relative flex items-center justify-between min-h-[72px] md:min-h-[88px]">
          {/* LOGO — click to firm website */}
          <a
            href="https://josfamilylaw.com"
            target="_blank"
            rel="noreferrer"
            data-testid="nav-logo"
            className="flex items-center shrink-0"
          >
            <img
              src="/brand/jos-logo.png"
              alt="Jos Family Law — visit josfamilylaw.com"
              className="h-9 md:h-11 w-auto select-none"
              draggable={false}
            />
          </a>

          {/* PHONE CTA — visible on all breakpoints; text scales down on mobile */}
          <a
            href="tel:+17147337066"
            data-testid="nav-phone"
            aria-label="Call (714) 733-7066"
            className="inline-flex items-center gap-2 md:gap-2.5 bg-teal text-ink hover:bg-ink hover:text-paper transition-colors duration-300 px-3 py-2 md:px-5 md:py-3 font-body text-[13px] md:text-[15px] font-medium whitespace-nowrap"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="md:w-[18px] md:h-[18px]"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            (714) 733-7066
          </a>
        </div>
      </div>
    </header>
  );
}
